import { Stepper as MuiStepper, type StepperProps } from "@mui/material";
import Step from "@mui/material/Step";
import clsx from "clsx";
import type { ReactNode } from "react";
import { CheckIcon, Circle, IconWrapper, StepLabel, StepperConnector, classes } from "./styles";

interface IStepperIconProps {
  active?: boolean;
  completed?: boolean;
}

const StepperIcon = ({ active, completed }: IStepperIconProps) => {
  return (
    <IconWrapper
      className={clsx({
        [classes.active]: !!active,
      })}
    >
      {completed ? <CheckIcon /> : <Circle active={!!active} />}
    </IconWrapper>
  );
};

interface IStepperProps extends StepperProps {
  id?: string;
  steps: ReactNode[];
  activeStep: number;
}

export const Stepper = ({ id, steps, activeStep, ...props }: IStepperProps) => {
  return (
    <MuiStepper id={id} alternativeLabel activeStep={activeStep} connector={<StepperConnector />} {...props}>
      {steps.map((label, index) => (
        <Step
          key={`stepper-step-${
            // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
            index
          }`}
        >
          <StepLabel StepIconComponent={StepperIcon}>{label}</StepLabel>
        </Step>
      ))}
    </MuiStepper>
  );
};
